import React, { Component } from 'react';
import { CTAButton } from './CTAButton';
import { TestimonialCard } from './TestimonialCard';
import { SidebarCTA } from './SidebarCTA';
import { StickyCTA } from './StickyCTA';
import { StarIcon, CheckIcon } from 'lucide-react';
export const Advertorial = () => {
  return <div className="bg-white min-h-screen" data-id="element-5">
      <header className="bg-gray-800 py-3 px-4 text-white flex justify-between items-center" data-id="element-6">
        <div className="flex items-center" data-id="element-7">
          <span className="font-medium" data-id="element-8">Women's Health & Beauty Today</span>
        </div>
        <div className="flex items-center" data-id="element-9">
          <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Flag_of_the_United_States.svg/1920px-Flag_of_the_United_States.svg.png" alt="US Flag" className="h-4 w-6 mr-2" data-id="element-10" />
          <span data-id="element-11">Trending in the US</span>
        </div>
      </header>
      <div className="bg-yellow-50 border border-yellow-200 p-3 max-w-4xl mx-auto mt-4" data-id="element-12">
        <div className="flex items-start" data-id="element-13">
          <div className="text-red-600 mr-2 font-bold" data-id="element-14">⚠️ UPDATE:</div>
          <div data-id="element-15">
            <span className="font-bold" data-id="element-16">
              Glisera™ Restore & Firm Oil Is Selling Out FAST! Grab Yours NOW
              with Fast FREE Shipping Across the US
            </span>
          </div>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-4 py-3 text-sm" data-id="element-17">
        <div className="flex items-center text-gray-600" data-id="element-18">
          <span data-id="element-19">Home</span>
          <span className="mx-2" data-id="element-20">/</span>
          <span data-id="element-21">Beauty</span>
          <span className="mx-2" data-id="element-22">/</span>
          <span data-id="element-23">Glisera™ Restore & Firm Oil</span>
        </div>
      </div>
      <main className="max-w-4xl mx-auto px-4 py-4" data-id="element-24">
        <div className="flex flex-col md:flex-row gap-8" data-id="element-25">
          <div className="md:w-2/3" data-id="element-26">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3" data-id="element-27">
              Dermatologists Are Finally Admitting What Women Over 45 Have Known
              All Along: Most Cellulite Creams Aren't Made for Aging Skin
            </h1>
            <h2 className="text-lg md:text-xl text-gray-600 mb-4" data-id="element-28">
              Why the $89 cream you bought at Sephora isn't working — and what
              women in menopause are using instead.
            </h2>
            <div className="flex items-center text-sm text-gray-600 mb-6" data-id="element-29">
              <div className="flex items-center mr-6" data-id="element-30">
                <div className="w-8 h-8 rounded-full bg-gray-300 mr-2 overflow-hidden" data-id="element-31">
                  <div className="w-full h-full bg-gray-200 flex items-center justify-center text-xs text-gray-500" data-id="element-32">
                    Author Photo
                  </div>
                </div>
                <span data-id="element-33">Posted by: Sarah Mitchell, Health & Beauty</span>
              </div>
              <div className="flex items-center" data-id="element-34">
                <span data-id="element-35">March 3, 2025</span>
                <span className="mx-2" data-id="element-36">|</span>
                <span data-id="element-37">📊 47,823 views</span>
              </div>
            </div>
            <div className="my-6" data-id="element-38">
              <div className="w-full rounded-lg overflow-hidden mb-2" data-id="element-39">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6rXig9wN29niLvRQQYheYo/Aveli-ceullite-treatment-before-after.webp" alt="Before and after comparison showing significant cellulite reduction on thighs after 8 weeks of Glisera use" className="w-full h-auto" data-id="element-40" />
              </div>
              <p className="text-sm text-gray-500 italic text-center" data-id="element-41">
                Real results after 8 weeks of using Glisera Restore & Firm Oil
              </p>
            </div>
            <div className="my-6 text-gray-700" data-id="element-42">
              <p className="mb-4" data-id="element-43">
                If you've noticed your cellulite getting worse after 45, you're
                not imagining it. You bought expensive creams, tried coffee
                scrubs, maybe even splurged on spa treatments. Nothing sticks.
                The cellulite keeps coming back, often worse than before.
              </p>
              <p className="mb-4" data-id="element-44">
                Here's what dermatologists are finally admitting:{' '}
                <strong data-id="element-45">
                  Most anti-cellulite products weren't designed for women over
                  45.
                </strong>
              </p>
              <p className="mb-4" data-id="element-46">
                Dr. Rebecca Chen, a board-certified dermatologist in San Diego,
                recently made waves when she said: "Most anti-cellulite creams
                are tested on women in their twenties and thirties — we're
                asking menopausal women to use products designed for completely
                different skin."
              </p>
              <p className="mb-6" data-id="element-47">
                Think about it. When was the last time you saw an anti-cellulite
                ad featuring a woman your age?
              </p>
              <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-48">
                Why Cellulite Suddenly Gets Worse After 45
              </h3>
              <div className="my-4" data-id="element-49">
                <div className="w-full rounded-lg overflow-hidden mb-2" data-id="element-50">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2QFDEDFZX5BDQFtXcrSxs2/ChatGPT_Image_3_%CE%9F%CE%BA%CF%84_2025%2C_12_11_03_%CF%80.%CE%BC..png" alt="Diagram showing how hormonal changes affect skin layers after 45, with labeled Epidermis, Dermis, and Fat Layer sections" className="w-full h-auto" data-id="element-51" />
                </div>
                <p className="text-sm text-gray-500 italic text-center" data-id="element-52">
                  How hormonal changes affect skin structure after 45
                </p>
              </div>
              <p className="mb-3" data-id="element-53">
                Around menopause, estrogen plummets. This triggers a cascade of
                changes:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-54">
                <li data-id="element-55">
                  <strong data-id="element-56">Collagen drops by up to 30%</strong> in the first five
                  years after menopause. The scaffolding that keeps skin smooth
                  weakens, allowing fat cells to push through and create
                  dimpling.
                </li>
                <li data-id="element-57">
                  <strong data-id="element-58">Circulation slows down.</strong> Lower estrogen means
                  reduced blood flow to your skin, making it harder to flush
                  toxins and deliver nutrients.
                </li>
                <li data-id="element-59">
                  <strong data-id="element-60">Skin loses elasticity.</strong> It becomes thinner,
                  less able to "bounce back," making cellulite more visible.
                </li>
                <li data-id="element-61">
                  <strong data-id="element-62">Lymphatic drainage becomes sluggish.</strong> Your
                  body retains more fluid, which makes cellulite appear even
                  more pronounced.
                </li>
              </ul>
              <p className="mb-6" data-id="element-63">
                Dr. Amanda Foster, cosmetic chemist with 20+ years formulating
                skincare, explains: "After 45, using the same products as a
                25-year-old is like using reading glasses when you need
                bifocals."
              </p>
              <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-64">
                Why Your Creams Keep Failing
              </h3>
              <div className="my-4" data-id="element-65">
                <div className="w-full rounded-lg overflow-hidden mb-2" data-id="element-66">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3jfw7K36bBWuzsECy6cAY5/Cream-vs-Oil.gif" alt="Comparison showing cream sitting on surface vs oil penetrating deeper into mature skin" className="w-full h-auto" data-id="element-67" />
                </div>
                <p className="text-sm text-gray-500 italic text-center" data-id="element-68">
                  Why oils penetrate mature skin better than creams
                </p>
              </div>
              <p className="mb-3" data-id="element-69">
                Traditional cellulite creams fall short for menopausal skin
                because:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-70">
                <li data-id="element-71">
                  <strong data-id="element-72">They focus on surface hydration only.</strong>{' '}
                  Temporary plumping doesn't address hormonal collagen loss.
                </li>
                <li data-id="element-73">
                  <strong data-id="element-74">They ignore the hormonal factor.</strong> They're
                  formulated for younger skin that still produces adequate
                  collagen.
                </li>
                <li data-id="element-75">
                  <strong data-id="element-76">The format is wrong.</strong> Thick creams sit on top
                  of skin rather than penetrating where cellulite forms.
                </li>
                <li data-id="element-77">
                  <strong data-id="element-78">They don't boost circulation.</strong> When blood flow
                  has decreased from lower estrogen, surface creams can't
                  counteract this.
                </li>
              </ul>
              <div className="bg-gray-100 p-4 rounded-lg mb-6 italic" data-id="element-79">
                <p data-id="element-80">
                  Jennifer M., 52, from Phoenix: "I spent over $1,000 on creams
                  and treatments. I'd see improvement for two weeks, then it all
                  came back. I felt like I was throwing money away."
                </p>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-81">
                What Women in Menopause Are Using Instead
              </h3>
              <p className="mb-3" data-id="element-82">
                Women over 45 are discovering a different approach: an oil
                specifically formulated for hormonally changing skin.
              </p>
              <p className="mb-3 font-bold" data-id="element-83">
                Not another cream. A targeted oil designed for menopausal
                biology.
              </p>
              <p className="mb-3" data-id="element-84">Why oil changes everything:</p>
              <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-85">
                <li data-id="element-86">
                  <strong data-id="element-87">Deeper penetration.</strong> Oil molecules pass
                  through the outer skin layer more effectively than water-based
                  creams — crucial for thinner menopausal skin.
                </li>
                <li data-id="element-88">
                  <strong data-id="element-89">Works with massage.</strong> Unlike creams that absorb
                  quickly, oils stay slippery enough for massage techniques that
                  stimulate circulation and lymphatic drainage.
                </li>
                <li data-id="element-90">
                  <strong data-id="element-91">Higher active concentration.</strong> Oils don't need
                  the fillers and emulsifiers that creams require.
                </li>
              </ul>
              <div className="my-8" data-id="element-92">
                <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-93">
                  Introducing Glisera™ Restore & Firm Oil: Made for Women Going
                  Through The Change
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-6" data-id="element-94">
                  <div className="h-64 md:h-64 bg-white rounded-lg flex items-center justify-center overflow-hidden" data-id="element-95">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7xahmXAPdZT1vwoeaGDhSs/Brand-Oil_4%3B3.gif" alt="Glisera Restore & Firm Oil bottle" className="w-full h-full object-contain" style={{
                    aspectRatio: '4/3'
                  }} data-id="element-96" />
                  </div>
                  <div className="h-64 md:h-64 bg-white rounded-lg flex items-center justify-center overflow-hidden" data-id="element-97">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/s9TEM3zrzySBj3VvaTpBXY/OIL-TEXTURE_4%3B3_%281%29.gif" alt="Close-up of golden oil texture being applied to skin" className="w-full h-full object-contain" style={{
                    aspectRatio: '4/3'
                  }} data-id="element-98" />
                  </div>
                  <div className="h-64 md:h-64 bg-white rounded-lg flex items-center justify-center overflow-hidden" data-id="element-99">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2tbtT7SZc5WnCXLhZ9mX3r/APPLICATION_4%3B3.gif" alt="Woman applying Glisera oil to thigh area with visible results" className="w-full h-full object-contain" style={{
                    aspectRatio: '4/3'
                  }} data-id="element-100" />
                  </div>
                </div>
                <p className="mb-4" data-id="element-101">
                  Glisera™ is the first restore and firm oil designed
                  specifically for women dealing with perimenopause and
                  menopause. Instead of trying to be everything to everyone, it
                  targets what happens with declining estrogen.
                </p>
                <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-102">
                  What Makes It Different:
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6" data-id="element-103">
                  <div className="flex items-start" data-id="element-104">
                    <CheckIcon className="text-green-600 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-105" />
                    <span data-id="element-106">Supports Collagen Production</span>
                  </div>
                  <div className="flex items-start" data-id="element-107">
                    <CheckIcon className="text-green-600 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-108" />
                    <span data-id="element-109">Boosts Circulation & Lymphatic Drainage</span>
                  </div>
                  <div className="flex items-start" data-id="element-110">
                    <CheckIcon className="text-green-600 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-111" />
                    <span data-id="element-112">Improves Skin Elasticity & Firmness</span>
                  </div>
                  <div className="flex items-start" data-id="element-113">
                    <CheckIcon className="text-green-600 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-114" />
                    <span data-id="element-115">Lightweight Oil Format (Non-Greasy)</span>
                  </div>
                </div>
                <div className="mb-6" data-id="element-116">
                  <p className="mb-2" data-id="element-117">
                    <strong data-id="element-118">The Hero Ingredient:</strong> Formulated with Gotu
                    Kola — clinically shown to improve skin elasticity and
                    support collagen synthesis — plus a targeted blend of
                    circulation-boosting botanicals and firming oils chosen
                    specifically for mature, hormonally changing skin.
                  </p>
                  <p data-id="element-119">
                    <strong data-id="element-120">The Ritual Component:</strong> This isn't just what
                    you apply — it's how you apply it. The 5-7 minute evening
                    massage technique actively stimulates circulation and
                    encourages lymphatic drainage while the botanicals work
                    deeper in your skin.
                  </p>
                </div>
                <div className="bg-gray-100 p-4 rounded-lg mb-6" data-id="element-121">
                  <h4 className="font-bold mb-2" data-id="element-122">Clinical Results:</h4>
                  <p className="mb-2" data-id="element-123">In a 6-week consumer study:</p>
                  <ul className="list-none space-y-1" data-id="element-124">
                    <li data-id="element-125">92% of women noticed firmer skin</li>
                    <li data-id="element-126">89% said their thighs looked smoother</li>
                    <li data-id="element-127">94% plan to continue using it</li>
                  </ul>
                </div>
              </div>
              <div className="my-8" data-id="element-128">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-129">
                  Real Women, Real Results
                </h3>
                <div className="space-y-4 mb-6" data-id="element-130">
                  <TestimonialCard name="Margaret K., 49, Austin, TX" content="I've spent thousands on cellulite treatments over the years. Everything stopped working after I hit 45. I found Glisera through a menopause support group and was skeptical, but the fact it was designed for our age group made me try it.
After three weeks, my thighs looked smoother. By six weeks, I could wear a dress I'd hidden for two years. Unlike everything else, the results are lasting. I feel like myself again." profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/gVoXHqBcwziNXx697Hwh4S/images_%2842%29.jpg" data-id="element-131" />
                  <TestimonialCard name="Theresa L., 54, Portland, OR" content="My dermatologist couldn't offer solutions beyond 'hydrate and exercise,' which I was already doing. What I appreciate about Glisera is the honesty — they acknowledge menopause changes your skin and you need a different approach.
Two months in, my skin feels firmer and looks smoother. It's become part of my self-care routine, and the results make it worth it." profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/kJinmhwswV676WYp4SqbNR/istockphoto-1290775513-612x612.jpg" data-id="element-132" />
                  <TestimonialCard name="Diana R., 47, Denver, CO" content="About a month in, the backs of my thighs look noticeably smoother. My skin has more elasticity — more 'bounce' to it.
But honestly, the best part is feeling like someone finally made a product FOR ME. Everything else seems designed for women half my age. I look forward to my evening routine now." profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/pAwJH2mj1ujdYn4moK9pgG/istockphoto-1180524344-612x612.jpg" data-id="element-133" />
                </div>
              </div>
              <div className="my-8" data-id="element-134">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-135">
                  The Evening Ritual (5-7 Minutes)
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-136">
                  <div className="flex flex-col" data-id="element-137">
                    <div className="w-full h-48 rounded-lg flex items-center justify-center mb-2 overflow-hidden" data-id="element-138">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/o9isRq8nqP3rFEENtxE7Sv/Gemini_Generated_Image_vkxh54vkxh54vkxh.png" alt="Woman in white bathrobe and head towel holding the Glisera product" className="w-full h-full object-cover" data-id="element-139" />
                    </div>
                    <p className="font-bold" data-id="element-140">
                      Step 1: Start with clean, damp skin
                    </p>
                    <p className="text-sm" data-id="element-141">
                      Apply after your evening shower for best absorption
                    </p>
                  </div>
                  <div className="flex flex-col" data-id="element-142">
                    <div className="w-full h-48 rounded-lg flex items-center justify-center mb-2 overflow-hidden" data-id="element-143">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/99VNhgfsixaogK1KNMf4J4/Gemini_Generated_Image_h9ywm1h9ywm1h9yw.png" alt="Woman dispensing Glisera oil into palm, showing proper amount" className="w-full h-full object-cover" data-id="element-144" />
                    </div>
                    <p className="font-bold" data-id="element-145">
                      Step 2: Apply a quarter-size amount
                    </p>
                    <p className="text-sm" data-id="element-146">
                      A little goes a long way with this concentrated formula
                    </p>
                  </div>
                  <div className="flex flex-col" data-id="element-147">
                    <div className="w-full h-48 rounded-lg flex items-center justify-center mb-2 overflow-hidden" data-id="element-148">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eQMjFw9yaR8xvwrXBqamBB/Gemini_Generated_Image_57ldq657ldq657ld.png" alt="Woman in white bathrobe applying oil to her thigh" className="w-full h-full object-cover" data-id="element-149" />
                    </div>
                    <p className="font-bold" data-id="element-150">
                      Step 3: Massage in upward, circular motions
                    </p>
                    <p className="text-sm" data-id="element-151">
                      Use firm pressure to stimulate circulation
                    </p>
                  </div>
                  <div className="flex flex-col" data-id="element-152">
                    <div className="w-full h-48 rounded-lg flex items-center justify-center mb-2 overflow-hidden" data-id="element-153">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7jBVdkVG31tML98pmNj3To/Gemini_Generated_Image_k05097k05097k050.png" alt="Close-up of woman's thigh showing smooth skin after application" className="w-full h-full object-cover" data-id="element-154" />
                    </div>
                    <p className="font-bold" data-id="element-155">Step 4: Let it absorb</p>
                    <p className="text-sm" data-id="element-156">
                      Non-greasy finish, absorbs in just a few minutes
                    </p>
                  </div>
                </div>
                <ol className="list-decimal pl-6 mb-6 space-y-3" data-id="element-157">
                  <li data-id="element-158">
                    Start with clean, slightly damp skin after your evening
                    shower.
                  </li>
                  <li data-id="element-159">
                    Apply a quarter-size amount to each area you're treating.
                  </li>
                  <li data-id="element-160">
                    Massage in upward, circular motions using firm pressure for
                    1-2 minutes per area.
                  </li>
                  <li data-id="element-161">
                    Let it absorb (takes just a few minutes, non-greasy finish).
                  </li>
                </ol>
                <div className="mb-6" data-id="element-162">
                  <h4 className="font-bold mb-2" data-id="element-163">What to Expect:</h4>
                  <ul className="list-none space-y-2" data-id="element-164">
                    <li data-id="element-165">
                      <strong data-id="element-166">Week 1:</strong> Skin feels softer, more hydrated
                    </li>
                    <li data-id="element-167">
                      <strong data-id="element-168">Weeks 2-3:</strong> Subtle changes in texture —
                      feels firmer
                    </li>
                    <li data-id="element-169">
                      <strong data-id="element-170">Weeks 4-8:</strong> Visible improvement in
                      cellulite appearance
                    </li>
                  </ul>
                  <p className="mt-2" data-id="element-171">
                    Most women see best results with consistent use over 6-8
                    weeks.
                  </p>
                </div>
              </div>
              <div className="my-8" data-id="element-172">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-173">
                  Your Questions Answered
                </h3>
                <div className="space-y-4 mb-6" data-id="element-174">
                  <div data-id="element-175">
                    <p className="font-bold" data-id="element-176">
                      "Is this just another cellulite cream?"
                    </p>
                    <p data-id="element-177">
                      No. It's an oil formulated specifically for menopausal
                      skin's unique challenges: declining collagen, reduced
                      circulation, loss of elasticity.
                    </p>
                  </div>
                  <div data-id="element-178">
                    <p className="font-bold" data-id="element-179">
                      "How is this different from other body oils?"
                    </p>
                    <p data-id="element-180">
                      Glisera contains targeted botanicals like Gotu Kola chosen
                      for their clinical ability to address hormonal skin
                      changes — not just a general moisturizer.
                    </p>
                  </div>
                  <div data-id="element-181">
                    <p className="font-bold" data-id="element-182">"Will it work for me?"</p>
                    <p data-id="element-183">
                      Designed for women 40-65 in perimenopause/menopause
                      dealing with cellulite that's worsened with hormonal
                      changes.
                    </p>
                  </div>
                  <div data-id="element-184">
                    <p className="font-bold" data-id="element-185">"Is it greasy?"</p>
                    <p data-id="element-186">
                      No. It absorbs within minutes without residue. Stays
                      slippery for massage, then absorbs beautifully.
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-gray-100 p-5 rounded-lg mb-8" data-id="element-187">
                <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-188">
                  Limited Time Offer — Act Now
                </h3>
                <p className="mb-3" data-id="element-189">
                  Due to increased demand, Glisera™ is offering a special
                  promotion for readers.
                </p>
                <p className="mb-4" data-id="element-190">
                  This promotional pricing helps more women discover a solution
                  actually designed for them. Many women order multiple bottles
                  to lock in the discount and ensure consistent use over several
                  months.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4" data-id="element-191">
                  <div className="flex items-start" data-id="element-192">
                    <CheckIcon className="text-green-600 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-193" />
                    <span data-id="element-194">30-Day Money-Back Guarantee</span>
                  </div>
                  <div className="flex items-start" data-id="element-195">
                    <CheckIcon className="text-green-600 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-196" />
                    <span data-id="element-197">Available directly from manufacturer</span>
                  </div>
                  <div className="flex items-start" data-id="element-198">
                    <CheckIcon className="text-green-600 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-199" />
                    <span data-id="element-200">Authentic formula, no counterfeits</span>
                  </div>
                </div>
                <p data-id="element-201">
                  If you don't feel it's working for you, return it within 30
                  days for a full refund.
                </p>
              </div>
              <div className="mb-8" data-id="element-202">
                <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-203">
                  The Bottom Line
                </h3>
                <p className="mb-3" data-id="element-204">
                  If you're over 45 and frustrated because nothing works for
                  your cellulite anymore, you're not failing — you've been using
                  solutions designed for someone else's biology.
                </p>
                <p className="mb-3" data-id="element-205">
                  Menopause changes how your skin behaves. Collagen declines.
                  Circulation slows. Elasticity decreases. These biological
                  changes require a different approach.
                </p>
                <p className="mb-3" data-id="element-206">
                  Glisera™ Restore & Firm Oil acknowledges and addresses the
                  specific challenges of menopausal skin. It's about more than
                  cellulite — it's about feeling seen and reclaiming confidence
                  during a time of change.
                </p>
                <p className="mb-6" data-id="element-207">
                  You deserve products designed for your life stage. You deserve
                  to feel comfortable in your skin. And you deserve results that
                  last.
                </p>
              </div>
              <CTAButton data-id="element-208" />
            </div>
          </div>
          <div className="md:w-1/3 md:sticky md:top-4 h-fit" data-id="element-209">
            <SidebarCTA data-id="element-210" />
          </div>
        </div>
      </main>
      <footer className="bg-gray-100 py-6 px-4 text-xs text-gray-600 mb-16 md:mb-0" data-id="element-211">
        <div className="max-w-3xl mx-auto" data-id="element-212">
          <p className="mb-4" data-id="element-213">
            This is an advertorial and not an actual news article, blog, or
            consumer protection update. Results may vary from person to person.
            These testimonials may be real or fictitious. This information is
            not intended to diagnose, treat, cure, or prevent any disease.
            Advertising Disclosure: This website and the products & services
            referred to on the site are advertising marketplaces. Any
            photographs of persons used on this site may be models.
          </p>
          <p className="mb-4" data-id="element-214">
            30-day money-back guarantee. Terms and conditions apply.
          </p>
          <div className="flex flex-wrap justify-center text-center mb-4" data-id="element-215">
            <span className="mx-2" data-id="element-216">About Us</span>
            <span className="mx-2" data-id="element-217">|</span>
            <span className="mx-2" data-id="element-218">Terms of Use</span>
            <span className="mx-2" data-id="element-219">|</span>
            <span className="mx-2" data-id="element-220">Privacy Policy</span>
            <span className="mx-2" data-id="element-221">|</span>
            <span className="mx-2" data-id="element-222">Contact</span>
          </div>
          <p className="text-center" data-id="element-223">
            ©2025 Women's Health & Beauty Today. All Rights Reserved.
          </p>
        </div>
      </footer>
      <StickyCTA data-id="element-224" />
    </div>;
};